<template>
  <div>
    <iw-breadcrumb separator=">">
      <iw-breadcrumb-item :to="{ path: '/enterprise' }">
        企业动态分析
      </iw-breadcrumb-item>
      <iw-breadcrumb-item to="/enterprise/brand-overview">
        厂商品牌概况
      </iw-breadcrumb-item>
    </iw-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  methods: {
    getBreadcrumb() {}
  }
};
</script>
